import React from 'react'
import { Field, useFieldState } from 'formular'
import { useCallback } from 'sb-hooks'
import SelectableRating, { SelectableRatingProps } from 'components/_new/controls/SelectableRating/SelectableRating'


type SelectableRatingFieldProps = {
  field: Field<number | string>
  onChange?: (value: number) => void
} & Omit<SelectableRatingProps, 'value' | 'onChange'>

const SelectableRatingField: React.FunctionComponent<SelectableRatingFieldProps> = ({ field, onChange, ...rest }) => {
  const { value } = useFieldState(field)

  const handleChange = useCallback((newValue) => {
    field.set(newValue)
    // to remove an error
    field.debounceValidate()

    if (typeof onChange === 'function') {
      onChange(newValue)
    }
  }, [ field, onChange ])

  return (
    <SelectableRating
      {...rest}
      value={Number(value)}
      onChange={handleChange}
    />
  )
}


export default SelectableRatingField
